// Los avisos (toasts) Papel: sonner sin next-themes, con el tema que ya lleva <html class="dark">.
// Éxito 4 s, con « Deshacer » cuando la acción se puede deshacer; error con su referencia.
import { Toaster as Sonner, toast } from "sonner";
// La CSP du panel (style-src 'self') bloque la balise <style> que sonner injecte lui-même :
// sans ce fichier, les avis s'affichaient sans mise en forme en production.
import "sonner/dist/styles.css";

export function Avisos() {
  const oscuro = typeof document !== "undefined" && document.documentElement.classList.contains("dark");
  return (
    <Sonner
      theme={oscuro ? "dark" : "light"}
      position="bottom-center"
      duration={4000}
      toastOptions={{
        classNames: {
          toast: "rounded-lg border border-border bg-card text-foreground shadow-papel-f font-sans",
          description: "text-muted-foreground",
          actionButton: "rounded-md bg-primary text-primary-foreground",
          error: "text-non",
          success: "text-foreground",
        },
      }}
    />
  );
}

export { toast };
